import type { CrmTranslate } from './crm-copy';

export function createCrmSharedUiCopy(t: CrmTranslate) {
  return {
    sharedUi: {
      pagination: {
        defaultEntityLabel: t('crm.sharedUi.pagination.defaultEntityLabel'),
        showingRange: (start: number, end: number, total: string, label: string) =>
          t('crm.sharedUi.pagination.showingRange', {
            values: { start, end, total, label },
          }),
        firstPage: t('crm.sharedUi.pagination.firstPage'),
        previousPage: t('crm.sharedUi.pagination.previousPage'),
        nextPage: t('crm.sharedUi.pagination.nextPage'),
        lastPage: t('crm.sharedUi.pagination.lastPage'),
      },
      entityCard: {
        select: (name: string) =>
          t('crm.sharedUi.entityCard.select', {
            values: { name },
          }),
        open: (name: string) =>
          t('crm.sharedUi.entityCard.open', {
            values: { name },
          }),
        previousMedia: t('crm.sharedUi.entityCard.previousMedia'),
        nextMedia: t('crm.sharedUi.entityCard.nextMedia'),
        showMedia: (index: number) =>
          t('crm.sharedUi.entityCard.showMedia', {
            values: { index },
          }),
        added: (date: string) =>
          t('crm.sharedUi.entityCard.added', {
            values: { date },
          }),
      },
      searchableSelector: {
        placeholder: t('crm.sharedUi.searchableSelector.placeholder'),
        clearSelection: t('crm.sharedUi.searchableSelector.clearSelection'),
        searching: t('crm.sharedUi.searchableSelector.searching'),
        minCharacters: t('crm.sharedUi.searchableSelector.minCharacters'),
        noResultsFor: (query: string) =>
          t('crm.sharedUi.searchableSelector.noResultsFor', {
            values: { query },
          }),
      },
      entitySelector: {
        placeholder: t('crm.sharedUi.entitySelector.placeholder'),
        create: t('crm.sharedUi.entitySelector.create'),
        noResults: t('crm.sharedUi.entitySelector.noResults'),
        searching: t('crm.sharedUi.entitySelector.searching'),
        minCharacters: (count: number) =>
          t('crm.sharedUi.entitySelector.minCharacters', {
            values: { count },
          }),
      },
      colorPicker: {
        presetNames: {
          blue: t('crm.sharedUi.colorPicker.presetNames.blue'),
          green: t('crm.sharedUi.colorPicker.presetNames.green'),
          amber: t('crm.sharedUi.colorPicker.presetNames.amber'),
          red: t('crm.sharedUi.colorPicker.presetNames.red'),
          violet: t('crm.sharedUi.colorPicker.presetNames.violet'),
          pink: t('crm.sharedUi.colorPicker.presetNames.pink'),
        },
        chooseAnyColor: t('crm.sharedUi.colorPicker.chooseAnyColor'),
        enterHexColorCode: t('crm.sharedUi.colorPicker.enterHexColorCode'),
        colorLabel: (name: string) =>
          t('crm.sharedUi.colorPicker.useColor', {
            values: { name },
          }),
      },
      confirmationModal: {
        confirm: t('crm.sharedUi.confirmationModal.confirm'),
        cancel: t('crm.sharedUi.confirmationModal.cancel'),
        close: t('crm.sharedUi.confirmationModal.close'),
      },
      close: t('crm.sharedUi.close'),
      loadingDelight: {
        preparing: (entity: string) =>
          t('crm.sharedUi.loadingDelight.preparing', {
            values: { entity },
          }),
        items: {
          contactsSearchTip: t('crm.sharedUi.loadingDelight.items.contactsSearchTip'),
          contactsDedupeTip: t('crm.sharedUi.loadingDelight.items.contactsDedupeTip'),
          contactsProgress: t('crm.sharedUi.loadingDelight.items.contactsProgress'),
          companiesIcpTip: t('crm.sharedUi.loadingDelight.items.companiesIcpTip'),
          companiesArrTip: t('crm.sharedUi.loadingDelight.items.companiesArrTip'),
          companiesProgress: t('crm.sharedUi.loadingDelight.items.companiesProgress'),
          dealsNextStepTip: t('crm.sharedUi.loadingDelight.items.dealsNextStepTip'),
          dealsForecastTip: t('crm.sharedUi.loadingDelight.items.dealsForecastTip'),
          dealsProgress: t('crm.sharedUi.loadingDelight.items.dealsProgress'),
          qualificationWisdom: t('crm.sharedUi.loadingDelight.items.qualificationWisdom'),
          winRateWisdom: t('crm.sharedUi.loadingDelight.items.winRateWisdom'),
          seasonalRenewals: t('crm.sharedUi.loadingDelight.items.seasonalRenewals'),
          draftNewThisWeekSegment: t('crm.sharedUi.loadingDelight.items.draftNewThisWeekSegment'),
          createRenewalsList: t('crm.sharedUi.loadingDelight.items.createRenewalsList'),
          renewalsQ3Name: t('crm.sharedUi.loadingDelight.items.renewalsQ3Name'),
          applyNextStepTemplate: t('crm.sharedUi.loadingDelight.items.applyNextStepTemplate'),
        },
        ctas: {
          startDraft: t('crm.sharedUi.loadingDelight.ctas.startDraft'),
          createDraft: t('crm.sharedUi.loadingDelight.ctas.createDraft'),
          queue: t('crm.sharedUi.loadingDelight.ctas.queue'),
        },
      },
      toast: {
        closeNotification: t('crm.sharedUi.toast.closeNotification'),
      },
    },
  };
}
